var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mark-line"},_vm._l((_vm.lines),function(line){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.lineStatus[line] || false),expression:"lineStatus[line] || false"}],key:line,ref:line,refInFor:true,staticClass:"line",class:line.includes('x')? 'xline' : 'yline'})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }